'use client';

import ExploreProductAccordion from '@/components/products/ExploreProductAccordion/ExploreProductAccordion';
import LucideIcon from '@/components/ui/LucideIcon';
import { Flex, Heading } from '@chakra-ui/react';
import SectionContainer from '@/components/shared/SectionContainer';
import { SafeLink } from '@/components/ui/SafeLink';

const ExploreProductsSection = () => {
  return (
    <SectionContainer containerInnerProps={{ flexDirection: 'column', gap: 12, paddingY: 12 }}>
      <Flex asChild alignItems="center" gap={4} width="100%" justify={{ base: 'space-between', tablet: 'start' }}>
        <SafeLink href="/shop" width="100%" _hover={{ textDecoration: 'none' }}>
          <Heading as="h2" color="neutral.80" textStyle="heading2" fontWeight="regular">
            Explore Our Products
          </Heading>
          <LucideIcon name="ChevronRight" boxSize={6} color="neutral.80" />
        </SafeLink>
      </Flex>

      <ExploreProductAccordion />
    </SectionContainer>
  );
};

export default ExploreProductsSection;
